import { Component, OnInit } from '@angular/core';
import { AlertService } from '../services/alert.service';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { NgIf } from '@angular/common';
import { FeedbackService } from '../services/feedback.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [TranslateModule, NgIf, ReactiveFormsModule],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.css'
})
export class FeedbackComponent implements OnInit {

  baseApiUrl = environment.baseApiUrl;

  currentLanguage: string = '';
  
  constructor(private alertService: AlertService, private translate: TranslateService, private feedbackService: FeedbackService, private router: Router) {}

  createFeedbackForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    phone_number: new FormControl('', [Validators.required]),
    email: new FormControl(''),
    comment: new FormControl('', [Validators.required]),
  });


  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    })
  }

  showSuccess() {
    this.alertService.success("Thank you so much for your feedback!");
  }

  showSuccessKh() {
    this.alertService.successKh("សូមថ្លែងអំណរគុណសម្រាប់មតិយោបល់!");
  }

  onSave() {
    if (this.createFeedbackForm.invalid) {
      this.alertService.error('Please fill in all required fields.');
      return;
    }

    const requestBody = {
      name: this.createFeedbackForm.get('name')?.value,
      phone_number: this.createFeedbackForm.get('phone_number')?.value,
      email: this.createFeedbackForm.get('email')?.value,
      comment: this.createFeedbackForm.get('comment')?.value
    };

    this.feedbackService.createFeedback(requestBody).subscribe(
      () => {
        this.alertService.success('Feedback is created successfully.');
        this.router.navigate(['/']);
      },
      (error) => {
        this.alertService.error(error.error.message);
      }
    )
  }

}
